<template>
  <b-modal  ref="modal" visible size="lg" :hide-footer="true" title="Retour details" @hidden="$emit('close')">
  <refund-form :order-id="orderId" :refundId="refundId" :includeRefundShipmentCosts="includeRefundShipmentCosts" ></refund-form>

  </b-modal>
</template>

<script>
import RefundForm from './RefundForm.vue'

export default {
  components: {
    RefundForm
  },
  props: {
    orderId: Number,
    refundId: Number,
    includeRefundShipmentCosts: Boolean
  }
}
</script>

<style scoped>
a.disabled.block {
  cursor: not-allowed;
  opacity: 0.5;
}


</style>



// WEBPACK FOOTER //
// RefundDetailModal.vue?6decb62a